export default __webpack_public_path__ + "static/media/pan_to_center_icon.8245cea3.png";